/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./report-list.component.scss.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./report-list.component";
var styles_ReportListComponent = [i0.styles];
var RenderType_ReportListComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_ReportListComponent, data: {} });
export { RenderType_ReportListComponent as RenderType_ReportListComponent };
export function View_ReportListComponent_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "p", [], null, null, null, null, null)), (_l()(), i1.ɵted(-1, null, ["\n  report-list works!\n"])), (_l()(), i1.ɵted(-1, null, ["\n"]))], null, null); }
export function View_ReportListComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "app-report-list", [], null, null, null, View_ReportListComponent_0, RenderType_ReportListComponent)), i1.ɵdid(1, 114688, null, 0, i2.ReportListComponent, [], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var ReportListComponentNgFactory = i1.ɵccf("app-report-list", i2.ReportListComponent, View_ReportListComponent_Host_0, {}, {}, []);
export { ReportListComponentNgFactory as ReportListComponentNgFactory };



// WEBPACK FOOTER //
// /opt/app/src/app/features/report/report-list/report-list.component.ngfactory.js.pre-build-optimizer.js